import { ProgressiveBarService } from "./../../shared/progressive-bar/progressive-bar.service";
import { Component, OnInit } from "@angular/core";
import { CommonService } from "../common.service";
import { WebcallsService } from "src/app/webcalls.service";
import { DataproviderService } from "src/app/dataprovider.service";
import { TooltipTypesEnum } from "src/app/shared/tooltip-types.enum";

@Component({
  selector: "app-system",
  templateUrl: "./system.component.html",
  styleUrls: ["./system.component.scss", "./system.component.responsive.scss"],
  host: {
    class: "d-block bg-standard p-b-104",
  },
})
export class SystemComponent implements OnInit {
  title: string = "b2c.IDS_SYSTEMS";
  subtitle: string = "b2c.IDS_SYSTEMS_SUB";
  showSubtitle: boolean = true;
  question: string = "b2c.IDS_SYSTEMS_QUE";
  activePage: string = "systems";
  nextPage: string = "";
  defaultSystems: any = ["LU1", "FTT", "COV", "QDC", "QDP", "SER"];
  eventCategory: string = "IDS_GTAG_CATEGORY";
  eventLabel: string = "IDS_SYSTEMS_LABEL_".concat(
    this.ds.getWhatToDo().name.toString()
  );
  dataEntries: any = [];

  excludeSystem: string[] = ["COV", "FTT", "QDC", "QDP", "SER"];
  includeSystemMobile: string[] = ["LU1"];
  excludeSystemMobile: string[] = this.excludeSystem.concat(
    this.includeSystemMobile
  );
  openVideoModal = false;
  videoModalUrl: string = null;

  tooltipType: TooltipTypesEnum = TooltipTypesEnum.DISCOVER;

  constructor(
    private cs: CommonService,
    private ws: WebcallsService,
    private ds: DataproviderService,
    private progressiveBarService: ProgressiveBarService
  ) {
    this.cs.setParams(
      this.title,
      this.subtitle,
      this.question,
      this.activePage,
      this.nextPage,
      true,
      true,
      false,
      true,
      null,
      false,
      true,
      this.eventCategory,
      this.eventLabel,
      false,
      null,
      true,
      this.showSubtitle,
      false
    );
    this.progressiveBarService.setProgressiveBarLengthByPageIndex(4);
  }

  ngOnInit() {

    if (this.ds.getBoolHavingBTicino()){
      let index = this.defaultSystems.indexOf('LU1');
      if (index >= 0) {
        this.defaultSystems.splice(index, 1);
      }
    } else {
      this.defaultSystems = ["LU1", "FTT", "COV", "QDC", "QDP", "SER"];
    }

    this.wsCall();
  }

  filterSystem(sys: {}) {
    return (
      sys["Code"] !== "SER" &&
      sys["Code"] !== "COV" &&
      sys["Code"] !== "FTT" &&
      sys["Code"] !== "QDC" &&
      sys["Code"] !== "QDP"
    );
  }

  setNextPage() {
    let whatToDoSelection = this.ds.getWhatToDo();
    if (
      this.dataEntries.find((s) => s["Code"] === "LOC" && s["checked"] === true)
    )
      this.nextPage = "internalunit";
    else if (
      this.dataEntries.find((s) => s["Code"] == "ANF" && s["checked"] === true)
    )
      this.nextPage = "softsecurity";
    else if (
      this.dataEntries.find((s) => s["Code"] == "TER" && s["checked"] === true)
    )
      this.nextPage = "smartthermo";
    else if (whatToDoSelection.ID == 3 && this.ds.getBoolHavingBTicino()) {
      this.nextPage = "times";
    } else {
      this.nextPage = "finishing";
    }
    this.updateNextPage();
  }

  updateNextPage() {
    this.cs.updateNextPage(this.nextPage);
  }

  setDataEntries(data: any[]) {
    let savedSystems = this.ds.getSystems();

    if (savedSystems == undefined) {
      savedSystems = this.ds.getCachedSystems();
    }

    let system;
    data.forEach((sys) => {
      if (savedSystems) {
        system = savedSystems.find((s) => s.ID === sys.ID);
      } else {
        system = null;
      }
      if (
        !(
          this.ds.getTechnologyID() == 2 &&
          this.ds.getHomeAutomationSystems().includes(sys.Code)
        )
      ) {
        if (this.defaultSystems.includes(sys.Code)) {
          // comprende anche LU che deve rimanere selezionato sempre
          if (
            this.ds.whatToDoIsUpdateImplant() &&
            this.ds.getBoolHavingBTicino() &&
            this.excludeSystem.includes(sys.Code)
          ) {
            // ATTENZIONE: SER mai presente, probabilmente quindi mai selezionabile
            sys.checked = false;
          } else {
            sys.checked = true;
          }
        } else {
          sys.checked = system && system.checked ? true : false;
        }
        sys.State = sys.checked ? "selected" : "";
        sys.Custom = 0;
        sys.videoUrl = sys.Code + ".mp4";

        this.dataEntries.push(sys);
        if (sys.checked) {
          this.ds.updateSystemsSelected(sys);
        }
      }
    });
    this.setNextPage();
    this.cs.updateNextBtn(this.canConfirm());
  }

  wsCall() {
    if (
      this.ds.getCachedSystems() == undefined ||
      this.ds.getCachedSystems().length == 0
    ) {
      this.ws.getSystems(this.ds.getLocalizationID()).subscribe((data) => {
        if (Array.isArray(data)) {
          this.ds.setCachedSystems(data);
          this.setDataEntries(data);
          this.setGASelectionEvent();
        }
      });
    } else {
      this.setDataEntries(this.ds.getCachedSystems());
      this.setGASelectionEvent();
    }
  }

  dataEntriesUpdate(idSelected: number) {
    /* multi selection */
    let system = this.dataEntries.find((s) => s.ID === idSelected);
    if (system && !this.defaultSystems.includes(system.Code)) {
      system.checked = !system.checked;
      system.State = system.checked ? "selected" : "";
      this.ds.updateSystemsSelected(system);

      this.cs.updateNextBtn(this.canConfirm());
      this.setNextPage();

    }
  }

  onSelectorClicked(idSelected: number) {
    this.dataEntriesUpdate(idSelected);
    this.setGASelectionEvent();
  }

  canConfirm(){
    let f: boolean = false;
    let systemSel = this.dataEntries.find((s) => s.State === "selected");
    if (systemSel)
        f=true;
    return f;
  }

  setGASelectionEvent(){
    let listChooise: [{ key: string; value: number }];
    this.dataEntries.forEach(de => {
      let code = de.Code;
      if (code !== 'COV' && code !== "FTT" && code !== "QDC" && code !== "QDP"  && code !== "SER" ){
        let key = "STEP_2_" + de.Name;
        let value = 0;
        if (de.checked) value = 1;
        if (listChooise == undefined)
          listChooise = [{ key: key, value: value }];
        else listChooise.push({ key: key, value: value });
      }
    });
    this.cs.setGASelectionEvent("step_2", listChooise);
  }

  onInfoClick(entryId: number) {
    let entry = null;
    for (let i = 0; i < this.dataEntries.length; i++) {
      entry = this.dataEntries[i];
      if (entry && entry.ID === entryId) {
        break;
      }
    }

    if (entry && entry.videoUrl) {
      this.videoModalUrl = entry.videoUrl;
      this.openVideoModal = true;
    }
  }
}
